import { useEffect, useState } from "react";

/** Narrow, or short because it is held sideways. Matches phone.css and the camera's insets. */
const PHONE = "(max-width: 760px), (max-height: 500px)";

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(() => window.matchMedia(PHONE).matches);
  useEffect(() => {
    const query = window.matchMedia(PHONE);
    const onChange = (): void => setPhone(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);
  return phone;
}
